import { useState } from "react";
import { useMutation, useQuery } from "convex/react";
import { usePaginatedQuery } from "convex-helpers/react";
import { api } from "../../../../convex/_generated/api";
import { TeamFilesLibrary } from "./TeamFilesLibrary";

export function TeamFilesPanel({ conversationId, canManage }: { conversationId: string; canManage: boolean }) {
  const [archived, setArchived] = useState(false);
  const { results, status, loadMore } = usePaginatedQuery(api.communication.listTeamFiles, { conversationId, archived }, { initialNumItems: 100 });
  const current = useQuery(api.communication.currentTeamFile, { conversationId });
  const manage = useMutation(api.communication.manageTeamFile);
  return <TeamFilesLibrary loading={status === "LoadingFirstPage"} files={results} currentFile={current ?? null} archived={archived} onToggleArchive={() => { setArchived(value => !value); }} canManage={canManage} onManage={(attachmentId, operation) => manage({ attachmentId, operation })} hasMore={status === "CanLoadMore"} loadingMore={status === "LoadingMore"} onLoadMore={() => { loadMore(100); }} />;
}
